import type {ObservabilityFns} from 'src/internal/shared/observability/types';

export function reportRuntimeError(
  observabilityFns: ObservabilityFns | undefined,
  error: unknown,
  messagePrefix?: string,
) {
  if (!observabilityFns) {
    return;
  }

  const errorStack = error instanceof Error ? error.stack : undefined;
  const originalErrorMessage =
    error instanceof Error ? error.message : String(error);
  const fullMessage = messagePrefix
    ? `${messagePrefix}: ${originalErrorMessage}`
    : originalErrorMessage;

  observabilityFns.errors?.error(fullMessage, {
    project: 'sail_core',
    extras: {
      error,
      errorStack,
    },
  });
}
